export default {
  menuPosition: {
    title: 'Menü Positionen',
    notification: {
      save: {
        type: 'success',
        message: 'Menüpositionen erfolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      }
    }
  },
  metadata: {
    title: 'Reportdaten',
    notification: {
      save: {
        type: 'success',
        message: 'Report erfolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      }
    }
  },
  notification: {
    save: {
      type: 'success',
      message: 'Report Vorschaudaten erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    }
  }
}
